(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('CopyrightDialogController', CopyrightDialogController);

    CopyrightDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Copyright'];

    function CopyrightDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Copyright) {
        var vm = this;

        vm.copyright = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.copyright.id !== null) {
                Copyright.update(vm.copyright, onSaveSuccess, onSaveError);
            } else {
                Copyright.save(vm.copyright, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('virtuallibraryApp:copyrightUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
